(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@ali/visualengine"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@ali/visualengine"], factory);
	else if(typeof exports === 'object')
		exports["cn-ui-layout"] = factory(require("react"), require("@ali/visualengine"));
	else
		root["cn-ui-layout"] = factory(root["React"], root["VisualEngine"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__186__) {
return 